var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 475.72 375.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6e6e6;}.cls-2{fill:#fff;}.cls-3{fill:#ffb6b6;}.cls-4{fill:#3f3d56;}.cls-5{fill:#e4e4e4;}.cls-6{fill:#2f2e41;}.cls-7{fill:#6c63ff;}.cls-8{fill:#ffb8b8;}.cls-9{fill:#9e616a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_team_spirit_re_yl1v",
    "data-name": "undraw team spirit re yl1v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M393.19,294.05C405,283.39,422.64,278,437.41,284a73.38,73.38,0,0,0-33,38.11c-2.36,6.25-4.32,13.46-10.1,16.8-3.6,2.09-8.08,2.19-12.11,1.18s-7.74-3-11.38-5l-1,0C374.45,319.82,381.35,304.72,393.19,294.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-2",
    d: "M437.32,284.33a62.81,62.81,0,0,0-34.91,16.48,27,27,0,0,0-5.31,6.6,15.64,15.64,0,0,0-1.79,8c.07,2.58.43,5.21-.13,7.76a9.47,9.47,0,0,1-4.72,6.16c-2.89,1.67-6.21,2.19-9.47,2.59-3.62.44-7.38.85-10.52,2.88-.38.24-.73-.36-.36-.6,5.45-3.53,12.35-2.25,18.21-4.6,2.74-1.1,5.16-3,6-5.95.75-2.55.38-5.27.29-7.88a16.56,16.56,0,0,1,1.46-7.85,24.81,24.81,0,0,1,5-6.77A60.77,60.77,0,0,1,416.59,290a63.92,63.92,0,0,1,20.72-6.4c.45-.06.45.65,0,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-2",
    d: "M405.34,297.73a9.41,9.41,0,0,1,1-12.15c.32-.32.83.17.5.49a8.73,8.73,0,0,0-.94,11.3C406.21,297.73,405.6,298.09,405.34,297.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-2",
    d: "M395.11,314.06a18.11,18.11,0,0,0,13-2.6c.38-.24.74.36.36.6a18.88,18.88,0,0,1-13.5,2.67C394.49,314.67,394.67,314,395.11,314.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    d: "M423.14,287.65a5.33,5.33,0,0,0,4,3.11c.44.08.27.76-.18.68a5.94,5.94,0,0,1-4.41-3.43.35.35,0,1,1,.6-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M453.67,335.44l-.84-.11a70.86,70.86,0,0,0-11.37-.58c-.3,0-.6,0-.89,0A74.06,74.06,0,0,0,414,340.89a71.7,71.7,0,0,0-9.64,5.12c-4.26,2.69-8.65,5.95-13.4,7.05a13.12,13.12,0,0,1-1.5.27l-19.64-17a1.42,1.42,0,0,1-.08-.18l-.82-.65.47-.33c.08-.07.18-.13.26-.19l.18-.13.05,0,.15-.11c.89-.63,1.79-1.26,2.7-1.88,1.35-.93,0,0,0,0a105.54,105.54,0,0,1,22-11.83l.71-.26a68.07,68.07,0,0,1,10.77-3,59.46,59.46,0,0,1,6.07-.85A50.65,50.65,0,0,1,428,318c10.27,2.38,19.66,8,25.22,16.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-2",
    d: "M453.41,335.65a62.78,62.78,0,0,0-37.8-7.85,27.09,27.09,0,0,0-8.21,2.07,15.46,15.46,0,0,0-6.22,5.28c-1.5,2.1-2.8,4.42-4.79,6.11a9.45,9.45,0,0,1-7.47,2.08c-3.31-.41-6.27-2-9.12-3.63-3.15-1.83-6.4-3.78-10.13-4-.45,0-.37-.73.08-.7,6.48.46,11.21,5.64,17.31,7.29,2.84.76,5.94.68,8.38-1.13,2.13-1.59,3.47-4,5-6.12a16.64,16.64,0,0,1,5.89-5.39,25.28,25.28,0,0,1,8.1-2.38,61.05,61.05,0,0,1,19,.47,63.8,63.8,0,0,1,20.4,7.38c.39.22,0,.78-.42.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-2",
    d: "M419.8,327.09a9.41,9.41,0,0,1,8.14-9.07c.45-.06.57.63.12.69a8.73,8.73,0,0,0-7.56,8.46c0,.45-.71.37-.7-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-2",
    d: "M401.8,334a18.13,18.13,0,0,0,11.92,5.74c.45,0,.37.73-.08.7a18.91,18.91,0,0,1-12.39-6C401,334.09,401.49,333.65,401.8,334Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-2",
    d: "M440.08,329.77a5.33,5.33,0,0,0,1.31,4.88c.31.33-.24.77-.55.44a6,6,0,0,1-1.46-5.4.37.37,0,0,1,.39-.31A.36.36,0,0,1,440.08,329.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M83.33,304.66c9.69-14.7,27-25.33,44.49-23.05a81.16,81.16,0,0,0-24.68,49.94c-.77,7.34-.87,15.59-6.12,20.78-3.27,3.23-8,4.59-12.63,4.63s-9.11-1.08-13.57-2.2l-1.11.27C70.45,337.43,73.64,319.36,83.33,304.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-2",
    d: "M127.82,282a69.36,69.36,0,0,0-32.75,27.35,30,30,0,0,0-3.84,8.53,17.22,17.22,0,0,0,.3,9c.79,2.74,1.91,5.45,2,8.34a10.5,10.5,0,0,1-3.34,7.9c-2.63,2.58-6,4.06-9.4,5.4-3.74,1.48-7.66,3-10.44,6-.34.37-.89-.18-.56-.54,4.85-5.3,12.58-5.84,18.2-10,2.61-1.94,4.67-4.68,4.77-8,.09-2.94-1.06-5.74-1.88-8.51a18.11,18.11,0,0,1-.62-8.8,27.33,27.33,0,0,1,3.5-8.64,67.16,67.16,0,0,1,13.46-16.15,70.59,70.59,0,0,1,20.39-12.61c.46-.19.66.57.2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-2",
    d: "M97.34,305.21a10.4,10.4,0,0,1-2.27-13.28c.26-.43.94-.05.68.38a9.63,9.63,0,0,0,2.14,12.35c.38.32-.17.87-.55.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-2",
    d: "M91,325.53a20.1,20.1,0,0,0,13.15-6.38c.34-.37.89.17.55.54A20.9,20.9,0,0,1,91,326.31C90.46,326.34,90.46,325.57,91,325.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-2",
    d: "M113.58,289.48a5.88,5.88,0,0,0,5.13,2.22c.5,0,.5.74,0,.78A6.59,6.59,0,0,1,113,290a.39.39,0,0,1,0-.55.38.38,0,0,1,.54,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-1",
    d: "M159.53,332.1l-.94.12a77.19,77.19,0,0,0-12.32,2.54l-.94.28A81.86,81.86,0,0,0,118.64,349a79.75,79.75,0,0,0-8.88,8.16c-3.8,4.06-7.6,8.77-12.38,11.26a11.77,11.77,0,0,1-1.53.7L70.12,356.36l-.14-.17-1-.46c.13-.16.27-.32.4-.49a3.11,3.11,0,0,0,.23-.28c.06-.06.1-.12.15-.18l.05,0,.13-.17c.78-.92,1.57-1.84,2.36-2.75h0A116.55,116.55,0,0,1,92.5,333l.69-.48a76.39,76.39,0,0,1,10.68-6.24,67.08,67.08,0,0,1,6.26-2.6,55.81,55.81,0,0,1,17.12-3.18c11.64-.31,23.25,3.11,31.64,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-2",
    d: "M159.31,332.4a69.34,69.34,0,0,0-42.62,2.12,29.94,29.94,0,0,0-8.2,4.5,17.14,17.14,0,0,0-5.18,7.37c-1,2.66-1.76,5.5-3.42,7.87a10.44,10.44,0,0,1-7.42,4.3c-3.65.48-7.26-.38-10.75-1.35-3.89-1.07-7.9-2.25-12-1.5-.49.09-.6-.68-.11-.77,7-1.31,13.56,2.91,20.54,3,3.25,0,6.54-.92,8.65-3.54,1.84-2.29,2.6-5.22,3.61-7.93a18.39,18.39,0,0,1,4.8-7.4,27.84,27.84,0,0,1,8-4.8,67.51,67.51,0,0,1,20.48-4.79,70.9,70.9,0,0,1,23.87,2.21c.48.13.19.85-.29.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-2",
    d: "M121,332.6a10.4,10.4,0,0,1,6.19-12,.39.39,0,0,1,.31.71,9.63,9.63,0,0,0-5.73,11.14c.12.49-.65.6-.77.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-2",
    d: "M103.65,345A20,20,0,0,0,118,347.79c.49-.09.6.68.11.77a20.89,20.89,0,0,1-14.92-3C102.76,345.33,103.23,344.7,103.65,345Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-2",
    d: "M143.42,329.82a5.89,5.89,0,0,0,2.76,4.86c.42.26-.05.88-.47.62a6.59,6.59,0,0,1-3.06-5.37.4.4,0,0,1,.33-.44A.39.39,0,0,1,143.42,329.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-3",
    d: "M152.31,194.44a6.2,6.2,0,0,0,0-8.77,6.31,6.31,0,0,0-.84-.71l10.13-49-10.92,3.45-8.15,47.42a6.24,6.24,0,0,0,9.76,7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M175.73,63.4,169,58.29s-6-.42-7,10.35-7.68,52.1-7.68,52.1l-10.36,48,14.34,3.14,11.1-51.78,11.1-35.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-4",
    d: "M170.57,152.18l-32.48-25.25a2.43,2.43,0,0,1-.42-3.4l22.1-28.41a2.43,2.43,0,0,1,3.39-.43l32.47,25.25a2.42,2.42,0,0,1,.43,3.4L174,151.75a2.42,2.42,0,0,1-3.4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-2",
    d: "M170.39,149.56l-29.72-23.1a2.16,2.16,0,0,1-.37-3l20-25.76a2.15,2.15,0,0,1,3-.37l29.72,23.1a2.16,2.16,0,0,1,.37,3l-20,25.76a2.14,2.14,0,0,1-3,.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-5",
    d: "M144.57,125.8a.53.53,0,0,1-.09-.75l10.1-13a.53.53,0,1,1,.84.66l-10.1,13a.54.54,0,0,1-.75.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-5",
    d: "M146.24,127.11a.54.54,0,0,1-.09-.75l10.1-13a.52.52,0,0,1,.75-.09.54.54,0,0,1,.1.74L147,127a.54.54,0,0,1-.76.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-5",
    d: "M153.64,121a.54.54,0,0,1-.09-.75l4.38-5.63a.54.54,0,0,1,.75-.09.55.55,0,0,1,.1.75L154.4,121a.54.54,0,0,1-.76.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-5",
    d: "M155.9,132.1a.53.53,0,0,1-.09-.75l15.95-20.52a.54.54,0,0,1,.75-.09.55.55,0,0,1,.1.75l-16,20.52a.54.54,0,0,1-.75.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-5",
    d: "M157.57,133.4a.54.54,0,0,1-.09-.75l16-20.52a.54.54,0,0,1,.75-.1.53.53,0,0,1,.11.75h0l-15.95,20.52a.54.54,0,0,1-.75.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-5",
    d: "M161.37,136.36a.55.55,0,0,1-.09-.76l15.95-20.51a.54.54,0,0,1,.85.66l-16,20.51a.53.53,0,0,1-.75.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-5",
    d: "M163.05,137.66a.53.53,0,0,1-.09-.75l15.95-20.52a.54.54,0,0,1,.75-.09.55.55,0,0,1,.1.75l-16,20.52a.54.54,0,0,1-.75.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-5",
    d: "M166.85,140.61a.54.54,0,0,1-.09-.75l16-20.51a.54.54,0,0,1,.86.65h0l-15.95,20.51a.54.54,0,0,1-.76.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-5",
    d: "M168.53,141.92a.54.54,0,0,1-.1-.76l16-20.51a.53.53,0,0,1,.75-.1.54.54,0,0,1,.1.75h0l-15.95,20.51a.53.53,0,0,1-.75.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-2",
    cx: 141.87,
    cy: 165.52,
    r: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-6",
    d: "M174,13.86a52.79,52.79,0,0,1-3.78,12.08c-10,21.08,18.41,14.21,28.55,14.21,11.09,0,21.7,5.83,20.08-20.07C218.14,9,209.84,0,198.75,0,189.28,0,176,4.21,174,13.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-3",
    d: "M209.09,323h-9.45l-4.5-36.44h14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-6",
    d: "M214.08,339.4H207.3l-1.21-6.4-3.1,6.4H185a4,4,0,0,1-2.3-7.36l14.35-9.91v-6.47l15.09.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-3",
    d: "M265.22,311.11l-7.58,5.64-25.35-26.56,11.18-8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-6",
    d: "M279,321.27l-5.44,4.05-4.79-4.42,1.33,7-14.42,10.72a4,4,0,0,1-6.23-4.54l5.6-16.52-3.86-5.19,12.65-8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-3",
    d: "M178.15,155.33l44.85-7-8.92-26.83H178.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-6",
    d: "M220.09,135s17.92,15.49,9.65,59.63l-10.1,43.26,27.51,47.76-14,7.63-33.9-47.12L183.75,209.8,175.55,146Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-6",
    d: "M192.31,220.17l-1.08,16.7,3.16,49.45,15.67,5.39,3-50.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-1",
    d: "M187.49,45.71l17.33.67,6.91,11.47,15.77,3.08-9.41,47.6,1.73,27.1-15.7-.1a45.89,45.89,0,0,0-30.72,11.54h0l.47-35.17-6.75-26.26,1.52-27.52,12.68-1.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-3",
    cx: 197.09,
    cy: 23.83,
    r: 16.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-6",
    d: "M186,7.2a18.69,18.69,0,0,1,28.42,16.31c-8.32,2.09-17.05,3.69-25.92.5l-2.09-5.12L185.19,24c-2.7,1.1-5.41,2-8.12,0A19.09,19.09,0,0,1,186,7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-7",
    d: "M224.48,168.52l2.2,20A2.42,2.42,0,0,0,229,190.2h10.13a2.42,2.42,0,0,0,2.33-1.72l1.83-15.3a3.7,3.7,0,1,0,.95-7,2.43,2.43,0,0,0-1.85-.85H226.81a2.43,2.43,0,0,0-2.33,3.15Zm19.13,3.63,1.12-3.63a2.45,2.45,0,0,0,0-1.29h.14a2.64,2.64,0,0,1,0,5.28,2.59,2.59,0,0,1-1.3-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-3",
    d: "M239.77,190.22a6.21,6.21,0,0,1,.86-9.48l-9.88-49.08,10.91,3.5,7.91,47.47a6.24,6.24,0,0,1-9.8,7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-1",
    d: "M220.72,66l6.77-5.11s6-.42,7,10.35,7.68,52.1,7.68,52.1l10.36,48-14.34,3.14-11.1-51.77L216,87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    className: "cls-7",
    cx: 162.3,
    cy: 106.88,
    r: 3.83
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-3",
    d: "M40.1,367.49h8l3.8-30.8H40.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-6",
    d: "M38.06,364.89h2.25l8.78-3.57,4.7,3.56h0a10,10,0,0,1,10,10v.32H38.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-3",
    d: "M71.05,362.46l7.79,1.76L89.33,335l-11.5-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-6",
    d: "M69.64,359.47l2.19.5,9.35-1.56,3.8,4.52h0a10,10,0,0,1,7.56,12l-.07.31-25.12-5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-6",
    d: "M25.48,209,32.7,290s-2.71,48.58,6,65.67H51.39l6.27-70.1.79-47,27.14,39.7L68.3,354.47l15.59,1.4L112,273.05,81.12,195.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    className: "cls-8",
    cx: 33.04,
    cy: 61.57,
    r: 18.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-4",
    d: "M65.78,97.94,50.5,91.38,43.07,83.5l-18.59,3L19.55,95,3.6,109.79l18.7,84.54-.57,18.47s12,5.39,63.87-7c.62-.15-.68-.8-.68-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-6",
    d: "M13.68,72.14l-.39-.54a3.13,3.13,0,0,1-.15.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-6",
    d: "M51.57,47.94a11.93,11.93,0,0,0-6.22-6,11.39,11.39,0,0,0-8.51,0A17.13,17.13,0,0,0,28.77,39a9,9,0,0,0-7.7,3.27A13.38,13.38,0,0,1,19.72,44c-1.43,1.32-3.6,1.13-5.49.86l2.55,2.18-3.09.81,3.61,2.19c-3.49,2.09-5.08,6.66-4.66,10.82A22.84,22.84,0,0,0,17.2,71.59c.9-1.91.71-4.19.7-6.34s.38-4.85,2.2-6.12a7.31,7.31,0,0,1,4.29-.89,196.66,196.66,0,0,1,22.36,1.4,6.31,6.31,0,0,1,2.86.83c1.64,1.12,2,3.43,2.12,5.45A39.74,39.74,0,0,0,53,55.68,19,19,0,0,0,51.57,47.94Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    className: "cls-2",
    cx: 57.37,
    cy: 236.45,
    r: 29.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-4",
    d: "M57.37,206.48a30.78,30.78,0,0,0-4.5.34c-.77.11-1.51.26-2.25.43a29.95,29.95,0,0,0-12.7,52c.5.43,1,.84,1.54,1.23a30,30,0,1,0,17.9-54Zm0,58.63a28.45,28.45,0,0,1-16.94-5.56c-.53-.39-1-.79-1.55-1.22a28.64,28.64,0,0,1,12.78-50c.73-.15,1.46-.27,2.2-.36a29.23,29.23,0,0,1,3.5-.22,28.67,28.67,0,0,1,0,57.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    className: "cls-7",
    d: "M71.7,230.58H43a2,2,0,0,1-2-2h0a2,2,0,0,1,2-1.95H71.7a2,2,0,0,1,2,1.95h0A2,2,0,0,1,71.7,230.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    className: "cls-7",
    d: "M71.7,238.4H43a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H71.7a2,2,0,0,1,2,2h0A2,2,0,0,1,71.7,238.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    className: "cls-7",
    d: "M71.7,246.22H43a2,2,0,0,1-2-2h0a2,2,0,0,1,2-1.95H71.7a2,2,0,0,1,2,1.95h0A2,2,0,0,1,71.7,246.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-9",
    d: "M385.32,366.5H377l-4-32.3h12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-9",
    d: "M345.7,366.5h-8.37l-4-32.3h12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-6",
    d: "M346,375.23H320.25v-.32a10,10,0,0,1,10-10h0l4.7-3.57,8.78,3.57H346Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-6",
    d: "M386.69,375.23H360.94v-.32a10,10,0,0,1,10-10h0l4.7-3.57,8.78,3.57h2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-6",
    d: "M337.49,175.34l-12.73,77.49,3.47,11.55-4.55,8.18,6.67,71.82-2.7,6,7.57,4.67h15.4l.81-65,3.8-9.55v-5.26L363,235.53l1.42,55.53,2.26,9.56-1.9,6.81,2.48,4.77,6.57,44.23h17.27l-1.33-10.28h0a7.62,7.62,0,0,0,4-8.42l-1-4.51L395,319.88l4.1-74.4-1.15-60L377.75,170Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    className: "cls-9",
    cx: 366.67,
    cy: 59.78,
    r: 16.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-9",
    d: "M331.61,206.09a6.88,6.88,0,0,0-.16-9.71,8.54,8.54,0,0,0-.94-.77l6.24-23.6-12,4.05-4.08,21.79a6.9,6.9,0,0,0,11,8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    className: "cls-1",
    d: "M338.17,92.8l-2.58-.54-2.2,1.22s-6.15,8.2-6.15,15.71-7.51,79.92-7.51,79.92l13.66,6.14,10.93-56.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    className: "cls-6",
    d: "M380.72,48s4.2-8-5-8.75c0,0-7.87-7.14-15.89-1.3,0,0-4.38,0-6.77,4.95,0,0-3.44-1.31-4.2,2.19,0,0-2.52,7.29,0,13.86s3.35,7.29,3.35,7.29S348,52.49,358.11,51.76s21.34-7,22.18,1,2.1,10,2.1,10S390.37,51.3,380.72,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-2",
    d: "M439.34,272.56a5,5,0,0,1-3.29-1.25l-48.56-43.23a5,5,0,0,1-.41-7l31.11-34.94a5,5,0,0,1,7-.41L473.74,229a5,5,0,0,1,.41,7h0L443,270.9a4.92,4.92,0,0,1-3.41,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-4",
    d: "M439.34,272.87a5.2,5.2,0,0,1-3.5-1.33l-48.56-43.23a5.27,5.27,0,0,1-.43-7.43L418,185.93a5.27,5.27,0,0,1,7.43-.43L474,228.73a5.26,5.26,0,0,1,.44,7.43l-31.11,35a5.25,5.25,0,0,1-3.63,1.76ZM421.9,185.44a4,4,0,0,0-3,1.34L387.8,221.73a4,4,0,0,0,.32,5.63l48.57,43.23a4,4,0,0,0,5.63-.32h0l31.11-34.94a4,4,0,0,0-.32-5.64l-48.57-43.23a4,4,0,0,0-2.65-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-7",
    d: "M456.94,239.46a2.13,2.13,0,0,1-1.42-.54L417.4,205a2.14,2.14,0,0,1,2.85-3.2l38.12,33.93a2.14,2.14,0,0,1-1.43,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-7",
    d: "M449.67,247.63a2.13,2.13,0,0,1-1.42-.54l-38.12-33.94A2.14,2.14,0,1,1,413,210l38.12,33.94a2.14,2.14,0,0,1,.17,3,2.11,2.11,0,0,1-1.6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-7",
    d: "M442.41,255.8a2.19,2.19,0,0,1-1.43-.54l-38.12-33.94a2.14,2.14,0,0,1,2.85-3.2h0l38.12,33.94a2.14,2.14,0,0,1-1.42,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-9",
    d: "M398.81,207.48a6.88,6.88,0,0,1,3.76-9.84l0-24.4,10.58,7-1.66,22.1a6.91,6.91,0,0,1-12.72,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    className: "cls-1",
    d: "M399.79,99.48l4.72-4.55,3.47,2.5s3.42,4.1,6.15,16.4,0,79.91,0,79.91l-15-2.05,2-35.52-6.14-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-4",
    d: "M406.77,96l-15.92-7.6L380,78.41l-19.71-.15L354,86.53l-16.79,5.7L340,150.1l-1.9,4.45s1.33,1.2,1.93,1.88-.84,6.29-.84,6.29l-.81,6.11,2.26,1.62-2.94,3.47L337,179.4s51.32-12.76,61,8.37c.52,1.12-.74-9.79-.74-9.79L396,170l1.26-7.17,1.9-1.91-3.2-3.2,2-15.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-8",
    d: "M45.74,224.35a7.39,7.39,0,0,0-4.16-9.57,8.07,8.07,0,0,0-1.25-.36l-3.54-26-10.25,9,4.93,23.29a7.42,7.42,0,0,0,14.27,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101-2",
    "data-name": "Path 1101-2",
    className: "cls-4",
    d: "M5.56,109.31l-2.78.53L1.1,112s-2.71,10.66.38,18.11S27,212.4,27,212.4l16.08.46L30.51,152.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-8",
    d: "M69,220.54a7.38,7.38,0,0,1,.29-10.43,8.76,8.76,0,0,1,1-.8l-6.4-25.42,12.86,4.5,4.1,23.44A7.41,7.41,0,0,1,69,220.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101-3",
    "data-name": "Path 1101-3",
    className: "cls-4",
    d: "M63.33,98.82l2.78-.54,2.34,1.33s6.5,8.88,6.4,17,7.06,85.9,7.06,85.9l-14.74,6.42-11-61Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.e96febf3a85666700511e78972b98480.svg";
export { ForwardRef as ReactComponent };